import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDisabledSendIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 24,
		cy: 24,
		r: 23.5,
		fill: "white",
		stroke: "#D0D2D7"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M35.5097 18.3195C35.5144 18.3084 35.5168 18.2965 35.5168 18.2845C35.5168 18.2724 35.5144 18.2605 35.5097 18.2495C35.514 18.2297 35.514 18.2092 35.5097 18.1895C35.5097 18.1895 35.5097 18.1895 35.5097 18.1395C35.5142 18.113 35.5142 18.0859 35.5097 18.0595V17.9995V17.9395H35.4497H35.3897H35.3197H35.2097L12.7397 21.4095C12.6617 21.4213 12.5896 21.4578 12.5338 21.5136C12.4781 21.5694 12.4416 21.6415 12.4297 21.7195C12.4201 21.797 12.4341 21.8757 12.4697 21.9452C12.5054 22.0147 12.5611 22.072 12.6297 22.1095L17.6297 24.7695L17.8697 30.9395C17.86 30.9856 17.86 31.0333 17.8697 31.0795C17.9083 31.1213 17.952 31.1583 17.9997 31.1895H18.0797C18.1128 31.1952 18.1466 31.1952 18.1797 31.1895H18.2697H18.3597L21.9997 28.5695L24.9997 32.5695C25.0338 32.6169 25.0789 32.6554 25.1312 32.6815C25.1834 32.7077 25.2413 32.7207 25.2997 32.7195C25.3589 32.7187 25.417 32.7038 25.4692 32.676C25.5214 32.6481 25.5661 32.6082 25.5997 32.5595L35.4997 18.3395L35.5097 18.3195ZM20.5697 25.9995C20.5288 26.0325 20.4948 26.0733 20.4697 26.1195L18.5997 29.5195L18.3697 24.7995L30.9997 20.1095L20.5697 25.9995ZM31.4697 19.1095L17.9997 24.1295L13.9997 21.9995L31.4697 19.1095ZM19.4097 29.5695L20.8097 26.9995L21.5197 27.9395L19.4097 29.5695ZM25.2697 31.6895L21.2697 26.4595L33.9397 19.2795L25.2697 31.6895Z",
		fill: "#D0D2D7",
		stroke: "#D0D2D7",
		strokeWidth: .5
	})]
});
export default SvgDisabledSendIcon;
